export default __webpack_public_path__ + "static/survey-templates-dark-32afefe2f2b57235a41d5e1a48a48f29.png";